import { getCommaSeparatedList } from './getCommaSeparatedList'

/**
 * Opens the user's email client with a pre-filled `mailto:` link.
 *
 * - `to`: primary recipients (comma-separated)
 * - `bcc`: optional hidden recipients to keep emails private
 *
 * This does not send the email automatically; it just prepares it
 * in the user's email client.
 */
export const openMailClient = ({
  to,
  bcc,
}: {
  to: string[]
  bcc?: string[]
}): void => {
  const bccQueryParam =
    bcc && bcc.length > 0 ? `?bcc=${getCommaSeparatedList(bcc)}` : ''
  window.location.href = `mailto:${getCommaSeparatedList(to)}${bccQueryParam}`
}
